import React from 'react';

export const GeoZone = ({ getZone, geoRegionInZone, handleZone }) => {
  return (
    <div className="property-filter-block">
      {geoRegionInZone && (
        <label className="property-details-label">Zone</label>
      )}
      <div className="property-pill-grid">
        {geoRegionInZone &&
          React.Children.toArray(
            geoRegionInZone?.map((zone) => (
              <button
                type="button"
                className={`property-pill ${
                  // eslint-disable-next-line eqeqeq
                  getZone == zone?.id ? 'property-pill--active' : ''
                }`}
                onClick={handleZone}
                data-zone={zone?.id}
              >
                {zone?.text}
              </button>
            )),
          )}
      </div>
    </div>
  );
};
